import type { FaireProductEntity } from "../../entity_types/product";

export const p_phqjkpkvyb: FaireProductEntity = {
  token: "p_phqjkpkvyb",
  type: "product",
  name: "Amber & Moss - 7.2 oz Standard Candle",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/2f9e1043576ac119412049f4be3d19ca6e0ce0467ce6a42c27aa28aebac11687.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d03405ed0b8bd19e4e5134857b065e61a0e369928567cfcf480a51b0bde6af0f.jpeg",
    "https://cdn.faire.com/fastly/7135a95b76545731a4f00466f2ae50f58168ba1fa97a0210880127b2773eb967.jpeg",
    "https://cdn.faire.com/fastly/ff1d4d659ead0db6d5a74d27a403c65b22197e4adcd4a4f85cfed8c1bf676155.jpeg",
    "https://cdn.faire.com/fastly/3e5c4ce947afaa2f2a13a2ff4104969a32637e494f8f161f48c259c5b44dce62.jpeg",
    "https://cdn.faire.com/fastly/b140379e7c65365648b4e37b5c13608e3eaf8e67afafd384345bd924a295e1dd.jpeg",
    "https://cdn.faire.com/fastly/c92432806d41e3d6f3c618531fde5312106f715a6cf03bbac99e6996e1de4217.jpeg",
  ],
  priceDollars: 11,
  description:
    "A weekend in the mountains, sun gleaming through the canopy. Notes of sage, moss, and lavender.\n\n Our best-selling 7.2 oz Standard Size.This is our most popular size and is meant for dressers, countertops, nightstands – basically everywhere. \n\nHand-poured into apothecary inspired amber jars with our signature kraft label and a brass lid. Our candles are simple - they're all made with 100% domestically grown soy wax, fine fragrance oils, and cotton-core wicks. The fragrances we use are paraben-free, phthalate-free, and never (ever) tested on animals.\n\nBurns for 40-50 hours.",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:29.865Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
